import { IUserGroupSearchResult, UserProviderType } from "types";

export const groupsMock: IUserGroupSearchResult[] = [
  {
    id: "group-1",
    uuid: "group-uuid-1",
    name: "Engineering Team",
    userCount: 15,
    userCountWithProducts: 15,
    provider: UserProviderType.INTERNAL,
    parentId: null,
  },
  {
    id: "group-2",
    uuid: "group-uuid-2",
    name: "Design Team",
    userCount: 8,
    userCountWithProducts: 8,
    provider: UserProviderType.INTERNAL,
    parentId: null,
  },
  {
    id: "group-3",
    uuid: "group-uuid-3",
    name: "Marketing Department",
    userCount: 12,
    userCountWithProducts: 10,
    provider: UserProviderType.INTERNAL,
    parentId: null,
  },
  {
    id: "group-4",
    uuid: "group-uuid-4",
    name: "Sales Team",
    userCount: 20,
    userCountWithProducts: 20,
    provider: UserProviderType.INTERNAL,
    parentId: null,
  },
];
